import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import Layout from './Layout';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, hasRole, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user is authenticated
  if (!isAuthenticated()) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // Check role if required — requiredRole can be a single role string or an array of roles (any match passes)
  if (requiredRole) {
    const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    const hasAnyRequiredRole = requiredRoles.some(role => hasRole(role));
    if (!hasAnyRequiredRole) {
      console.log(`User doesn't have required role(s): ${requiredRoles.join(', ')}, redirecting to login`);
      return <Navigate to="/login" replace />;
    }
  }
  
  return <Layout>{children}</Layout>;
};

export default ProtectedRoute; 